(function() {
	'use strict';

	angular.module('returnLetterApp').controller(
			'ReturnLetterDetailController', ReturnLetterDetailController);

	ReturnLetterDetailController.$inject = [ '$scope', 'ReturnLetterService', '$location',
			'RETURN_LETTER', 'CommonService', '$window', 'Upload',
			'authExpiredInterceptor', '$log', '$base64', '$stateParams' ];

	function ReturnLetterDetailController($scope, ReturnLetterService, $location, RETURN_LETTER,
			CommonService, $window, Upload, authExpiredInterceptor, $log,
			$base64, $stateParams) {
		var detailCtr = this;
		var param = $stateParams;
		detailCtr.cancel = cancel;
//		detailCtr.doProcessLetter = doProcessLetter;
		detailCtr.errorMessage = null;
//		detailCtr.returnLetter = returnLetter;
		detailCtr.processResults = RETURN_LETTER.PROCESS_RESULTS;
		detailCtr.hasFile = false;
		detailCtr.isApproval = false;
		detailCtr.lstNationality = CommonService.query({
			masterurl : 'nationality'
		});
		detailCtr.lstProvince = CommonService.query({
			masterurl : 'province'
		});
		
		detailCtr.init = function() {
			detailCtr.policyNum = returnLetter.policyNum;
			detailCtr.reasonDesc = returnLetter.reasonDesc;
		}
		function cancel() {
			$uibModalInstance.dismiss('cancel');
		}
		;
		detailCtr.getAllDistrictByProvince = function(cityCode, cityDesc) {
			detailCtr.returnLetter.cityCodeUpdate = cityCode;
			detailCtr.returnLetter.cityDescUpdate = cityDesc;
			if (cityCode != null || cityCode != undefined
					&& (num != null || num != undefined)) {
				detailCtr.lstDistrict = CommonService.query({
					masterurl : 'district',
					provinceCode : cityCode
				});
			} else {
				detailCtr.lstDistrict = null;
			}
		};
		detailCtr.getAllWardByDistrict = function(districtCode, districtDesc) {
			detailCtr.returnLetter.districtCodeUpdate = districtCode
			detailCtr.returnLetter.districtDescUpdate = districtDesc;
			if (districtCode != null || districtCode != undefined
					&& (districtCode != null || districtCode != undefined)) {
				detailCtr.lstWard = CommonService.query({
					masterurl : 'ward',
					districtCode : districtCode
				});
			} else {
				detailCtr.lstWard = null;
			}
		};
		detailCtr.getWardDesc = function(wardCode, wardDesc) {
			detailCtr.returnLetter.wardCodeUpdate = wardCode
			detailCtr.returnLetter.wardDescUpdate = wardDesc;
		};
		detailCtr.download = function() {
			//danh cho ie
			if (navigator.appVersion.toString().indexOf('.NET') > 0) { // for IE browser
				if (detailCtr.returnLetter.archiveData.dataContent != undefined) {
					var byteCharacters = atob(detailCtr.returnLetter.archiveData.content);
					var byteNumbers = new Array(byteCharacters.length);
					for (var i = 0; i < byteCharacters.length; i++) {
						byteNumbers[i] = byteCharacters.charCodeAt(i);
					}
					var byteArray = new Uint8Array(byteNumbers);
					var blob = new Blob([ byteArray ], {
						type : detailCtr.returnLetter.archiveData.type + ';charset=utf-8'
					});
					window.navigator
							.msSaveBlob(blob, detailCtr.returnLetter.archiveData.dataName);
				} else {
					var blob = new Blob([ detailCtr.returnLetter.archiveData ], {
						type : detailCtr.returnLetter.archiveData.type + ';charset=utf-8'
					});
					window.navigator
							.msSaveBlob(blob, detailCtr.returnLetter.archiveData.dataName);
				}
			} else {
				//truong hop file da luu duoi database
				if (detailCtr.returnLetter.archiveData.content != undefined) {
					var byteCharacters = atob(detailCtr.returnLetter.archiveData.content);
					var byteNumbers = new Array(byteCharacters.length);
					for (var i = 0; i < byteCharacters.length; i++) {
						byteNumbers[i] = byteCharacters.charCodeAt(i);
					}
					var byteArray = new Uint8Array(byteNumbers);
					var blob = new Blob([ byteArray ], {
						type : detailCtr.returnLetter.archiveData.type + ';charset=utf-8'
					});
					var url = $window.URL || $window.webkitURL;
					var aTag = document.createElement("a");
					aTag.style = "display: none";
					aTag.href = url.createObjectURL(blob);
					aTag.download = detailCtr.returnLetter.archiveData.dataName;
					aTag.click();
				} else {
					//truong hop file luu tam tren man hinh
					var blob = new Blob([ detailCtr.returnLetter.archiveData ], {
						type : detailCtr.returnLetter.archiveData.type + ';charset=utf-8'
					});
					var url = $window.URL || $window.webkitURL;
					var aTag = document.createElement("a");
					aTag.style = "display: none";
					aTag.href = url.createObjectURL(blob);
					aTag.download = detailCtr.returnLetter.archiveData.dataName;
					aTag.click();
				}
			}
		};
		//check paramester 
		 if (param.txnId != undefined && param.txnId != '') {
			 $scope.loading= true;
			 var txnId = $base64.decode(param.txnId)
			 //get policy info
			 ReturnLetterService.get({uri : 'get-return-letter-detail',txnId : txnId
				},function(result) {
					$scope.loading= false;
					detailCtr.returnLetter = result;
					detailCtr.getAllDistrictByProvince(result.cityCodeUpdate, result.cityDescUpdate);
					detailCtr.getAllWardByDistrict(result.districtCodeUpdate, result.districtDescUpdate);
					detailCtr.returnLetter.country = 'VN';
					detailCtr.returnLetter.mobileCode = "84";
					detailCtr.returnLetter.homeCode = "84";
					detailCtr.returnLetter.compCode = "84";
					if(detailCtr.returnLetter.letterStatus =='APPROVAL') detailCtr.isApproval = true;
					else detailCtr.isApproval = false;
			 }, function(error){
				 $scope.loading= false;
			 });
		};
		
		/**
		 * View letter
		 */
		detailCtr.viewReport = function() {
        	if(detailCtr.returnLetter.transaction.txnId != null && detailCtr.returnLetter.transaction.txnId != undefined){
        		var txnId = detailCtr.returnLetter.transaction.txnId;
        		window.open(GLOBAL_URL+'api/ga/return-letter/view-report-address/'+txnId+'?access_token=' + authExpiredInterceptor.getToken(),'_blank');
        	}
        	
        };
        
        /**
         * print confirm letter
         */
        detailCtr.printAddress = function() {
        	if(detailCtr.returnLetter.transaction.txnId != null && detailCtr.returnLetter.transaction.txnId != undefined ){
        		 $scope.loading=true;
        		 ReturnLetterService.download({uri:'print-letter-address'}, detailCtr.returnLetter, function(result){
        			 $scope.loading=false;
        			 if(result){
        				 detailCtr.returnLetter.letterStatus = 'SUCCESS';
        				 $scope.addAlert('In thư xác nhận thành công.','success');
        			 }
        		 },
        		 function(error) {
        			 $scope.loading= false;
        			 $scope.addAlert('Có lỗi hệ thống. Vui lòng kiểm tra lại.','danger');
        		 });
        	}
        };
        
        	
        detailCtr.release=function(){
			$scope.loading=true;
			detailCtr.returnLetter.taskInstanceId=$base64.decode(param.taskId);
			ReturnLetterService.post({uri:'do-release-approve'},detailCtr.returnLetter, function(result) {
						 if(result){
							 $scope.loading=false;
							 window.location.href = GLOBAL_URL+'task#/common-task';
						 }
					}, function(error){
    		});
		};

		detailCtr.doApprovalLetter=function(){
			$scope.loading=true;
			detailCtr.returnLetter.taskInstanceId=$base64.decode(param.taskId);
			if(detailCtr.hasFile) {
				var data = [];
				if (detailCtr.returnLetter.policyNum !== null) {
					if (detailCtr.returnLetter.archiveData) {
						data['file'] = detailCtr.returnLetter.archiveData;
						data['returnLetterDTO'] = new Blob([ JSON
								.stringify(detailCtr.returnLetter) ], {
							type : "application/json"
						});
					}
					Upload.upload(
							{
								url : GLOBAL_URL
										+ 'api/ga/return-letter/do-send-to-las?_csrf='
										+ authExpiredInterceptor.getCSRF(),
								data : data
							}).then(
							function(resp1) {
								 $scope.loading=false;
								 detailCtr.isApproval = true;
								 detailCtr.returnLetter = resp1.data;
								$log.debug('Success ' + resp1.config.data.file.name
										+ 'uploaded. Response: ' + resp1.data);
							},
							function(resp2) {
								 $scope.loading=false;
							},
							function(evt) {
								 $scope.loading=false;
								var progressPercentage = parseInt(100.0
										* evt.loaded / evt.total);
								$log.debug('progress: ' + progressPercentage + '% '
										+ evt.config.data.file.name);
							});
				}
			}else {
				ReturnLetterService.post({uri:'do-send-to-las-not-file'},detailCtr.returnLetter, function(result) {
					if (result) {
						$scope.loading = false;
						detailCtr.isApproval = true;
						detailCtr.returnLetter = result;
					} else {
						detailCtr.isApproval = false;
						$scope.loading = false;
					}
				}, function(error){
					detailCtr.isApproval = false;
					$scope.loading = false;
				});
			}
		
		};
		
		detailCtr.changeFile=function(file){
			if(file)
				detailCtr.hasFile = true;
			else
				detailCtr.hasFile = false;
		}
		
	}
})();
